var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from 'react';
import { useOpts } from '../../../../context';
import { useGetLocalizedString } from '../../../../hooks/useGetLocalizedString';
import usePercentageSupported from './usePercentageSupported';
import useAmountSupported from './useAmountSupported';
var usePartialSwitchToggle = function () {
    var getLocalizedString = useGetLocalizedString();
    var opts = useOpts();
    var featureFlags = opts.featureFlags, amountSelection = opts.amountSelection;
    var percentageSupported = usePercentageSupported();
    var amountSupported = useAmountSupported();
    var options = useMemo(function () {
        return __spreadArray(__spreadArray(__spreadArray([], (amountSupported
            ? [{ label: getLocalizedString('AMOUNT'), value: 'amount' }]
            : []), true), (percentageSupported
            ? [{ label: getLocalizedString('PERCENTAGE'), value: 'percentage' }]
            : []), true), (!featureFlags.disableRemainderSwitch
            ? [{ label: getLocalizedString('REMAINDER'), value: 'remainder' }]
            : []), true);
    }, [
        featureFlags.disableRemainderSwitch,
        getLocalizedString,
        percentageSupported,
        amountSupported,
    ]);
    var value = useMemo(function () {
        return options.find(function (option) {
            return 'allocation' in amountSelection &&
                amountSelection.allocation.type === option.value;
        });
    }, [amountSelection, options]);
    return {
        options: options,
        value: value,
    };
};
export default usePartialSwitchToggle;
